import React, { useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { bool, func } from 'prop-types';
import _ from 'lodash';
import './index.scss';

const EditViewModal = ({
  isFromSaveCoupon,
  setEditViewModal,
  setIsEditCouponDrug,
  setIsEditDrug,
  setIsDeleteCouponDrug,
  setDeleteDrugModal,
  dataLayerEventObj,
  isEditDisabled,
  setDrugItems,
  drugItems
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  });

  return (
    <div className="editViewModal">
      <div
        className="transparentBg"
        onClick={() => setEditViewModal(false)}
      ></div>
      <div className="drugPopover">
        <button
          className="closePopover"
          onClick={() => setEditViewModal(false)}
          role="link"
        >
          <LazyLoadImage
            src="/content/images/icons/icon-black-close.svg"
            width="24px"
            height="24px"
            alt=""
          />
        </button>
        <ul>
          <li
            className={isEditDisabled && 'disabled'}
            onClick={() => {
              _.triggerGTMVirtualPageViewEvent({
                event: 'savedEditDrug',
                drugName: dataLayerEventObj.drugName,
                seoName: dataLayerEventObj.seoName,
                NDC: dataLayerEventObj.ndc,
                drugBrand: dataLayerEventObj?.drugType
                  ? dataLayerEventObj?.drugType
                  : dataLayerEventObj.isGeneric
                  ? 'Generic'
                  : 'Brand',
                drugForm: dataLayerEventObj.form,
                drugDosage: dataLayerEventObj.dosage,
                drugQuantity: dataLayerEventObj.quantity
              });
              let { id } = dataLayerEventObj;
              setDrugItems(
                drugItems.map(drug => ({
                  ...drug,
                  isEditLoading: isFromSaveCoupon
                    ? drug.drug.id == id
                    : drug.id == id && true
                }))
              );
              isFromSaveCoupon
                ? setIsEditCouponDrug(true)
                : setIsEditDrug(true);
              setEditViewModal(false);
            }}
          >
            <span>
              <LazyLoadImage
                src="/content/images/icons/icon-edit.svg"
                className="themeFocus"
                tabIndex="0"
                width="24px"
                height="24px"
                alt=""
              />
            </span>
            Edit drug
          </li>
          <li
            onClick={() => {
              isFromSaveCoupon
                ? setIsDeleteCouponDrug(true)
                : setDeleteDrugModal(true);
              setEditViewModal(false);
            }}
          >
            <span>
              <LazyLoadImage
                src="/content/images/icons/icon-delete.svg"
                className="themeFocus"
                tabIndex="0"
                width="24px"
                height="24px"
                alt=""
              />
            </span>
            Delete drug
          </li>
        </ul>
      </div>
    </div>
  );
};

EditViewModal.propTypes = {
  setEditViewModal: func,
  isFromSaveCoupon: bool,
  setIsEditCouponDrug: func,
  setIsEditDrug: func,
  setIsDeleteCouponDrug: func,
  setDeleteDrugModal: func
};

EditViewModal.defaultProps = {
  setEditViewModal: () => {},
  isFromSaveCoupon: false,
  setIsEditCouponDrug: () => {},
  setIsEditDrug: () => {},
  setIsDeleteCouponDrug: () => {},
  setDeleteDrugModal: () => {}
};

export default EditViewModal;
